export default function Solutions() {
  const solutions = [
    {
      title: '安全性システムのソリューション',
      description: '製薬企業における安全性情報管理業務を支える各種安全性システムに対し、導入支援から運用サポートまでを包括的に提供するソリューションを行っています。特に、Argus、LSMV、Vault Safetyなどの主要な安全性システムに精通したコンサルタントが、要件定義、システム導入、設定、テスト、運用支援まで幅広くサポートします。日本の医薬品規制や安全性業務の実務を深く理解した専門人材が、業務とシステムの双方の視点から最適なソリューションを提供します。国内規制やガイドラインに準拠した運用設計を行うことで、安全性情報の適切な管理と規制対応を実現します。さらに、システム導入後の運用改善やユーザーサポートにも対応し、安全性業務の効率化と品質向上を継続的に支援します。',
      image: 'https://public.readdy.ai/ai/img_res/e2ae72679b10bc665790681bf05ab919.jpg',
      features: ['Argus', 'LSMV', 'Vault Safety', '要件定義', 'システム導入', '運用支援'],
    },
    {
      title: '安全性システム周辺ツールのソリューション',
      description: '安全性システムの価値を最大限に引き出すため、周辺ツールを活用したソリューションサービスを提供します。MRが現場で収集した安全性情報を効率的に入力できる入力支援システムの構築や、データの正確性と入力効率の向上を支援します。また、BIツールを活用した帳票・レポートの作成により、安全性データを分かりやすく可視化し、迅速な状況把握と意思決定をサポートします。さらに近年では、AI技術を活用した安全性業務の自動化・効率化にも注力しています。症例情報の整理、データ確認、レポート作成などの業務にAIを活用することで、作業負担の軽減と業務スピードの向上を実現します。安全性システムと周辺ツールを組み合わせることで、安全性情報管理の高度化と業務効率の向上を総合的に支援します。',
      image: 'https://readdy.ai/api/search-image?query=Business%20intelligence%20dashboard%20and%20AI%20automation%20tools%20for%20pharmaceutical%20safety%20data%20visualization%20with%20charts%20graphs%20and%20automated%20reporting%20system%20modern%20digital%20interface%20with%20teal%20blue%20accents%20professional%20medical%20technology%20environment%20clean%20design&width=600&height=400&seq=solution-tools-002&orientation=landscape',
      features: ['入力支援システム', 'BIツール', 'AI自動化', 'データ可視化'],
    },
  ];

  return (
    <section id="solutions" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            ソリューション
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            製薬業界の安全性情報管理に特化した<br className="hidden lg:block" />
            包括的なITソリューションをご提案します
          </p>
        </div>

        <div className="space-y-24">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className={`flex flex-col ${
                index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
              } gap-12 items-center`}
            >
              <div className="flex-1">
                <div className="w-full h-80 rounded-2xl overflow-hidden shadow-xl">
                  <img
                    src={solution.image}
                    alt={solution.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="flex-1">
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  {solution.title}
                </h3>
                <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                  {solution.description}
                </p>
                <div className="flex flex-wrap gap-3">
                  {solution.features.map((feature, idx) => (
                    <span
                      key={idx}
                      className="px-4 py-2 bg-teal-50 text-teal-700 rounded-full text-sm font-medium"
                    >
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}